import React from 'react';
import { IntlProvider } from './src/common/intl/components/IntlProvider';
import { defaultLocale } from './src/common/navigation/types/config';
import { LOCAL_STORAGE_LANG_KEY } from './src/utils/redirectToPreferredLanguage';
import '@fontsource/poppins/400.css'; // Poids 400
import '@fontsource/poppins/500.css'; // Poids 500
import '@fontsource/poppins/600.css'; // Poids 600
import '@fontsource/poppins/700.css'; // Poids 700
import '@fontsource/poppins/900.css';
import { AnimatePresence } from 'framer-motion';
import { AnalyticsProvider } from './src/analytics/context/AnalyticsContext'; // Poids 900
import './src/style/global.css';
import '@fortawesome/fontawesome-svg-core/styles.css';

export const wrapPageElement = ({ element }) => {
  let initialLocale = defaultLocale;
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    const storedLocale = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
    if (storedLocale) {
      initialLocale = storedLocale;
    }
  }

  return (
    <IntlProvider defaultLocale={initialLocale}>
      <AnalyticsProvider>
        <AnimatePresence initial={false}>
          <div style={{ minWidth: `390px` }}>{element}</div>
        </AnimatePresence>
      </AnalyticsProvider>
    </IntlProvider>
  );
};
